
export default function SubPage({ title = "dupadupasdasd", description = "XDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD" }) {
    return (
        <div>
            {title}
            <p>{description}</p>
        </div >
    );
}
